module.exports = __webpack_public_path__ + "static/jacques_mayeux-d54c035ebeb81470be37ec61ecbe9af9.jpg";